<script>
import axios from "axios";
import _ from "lodash";
import TheValueAttestationStudentTableDiv from "./TheValueAttestationStudentTableDiv.vue";

export default {
  name: "TheGroupAttestationTable",

  components: {
    TheValueAttestationStudentTableDiv
  },

  props: {
    groupAttestations: Array,
    groupDisciplines: Array,
    tabPointDate: Number,
  },

}
</script>

<template>
  <div>
    <v-simple-table
      fixed-header
      height="700px"
    >
      <template v-slot:default>
        <thead :style="{'height': '200px'}">
        <tr>
          <th>
            №
          </th>
          <th :style="{'min-width': '350px'}">
            Фамилия, Имя, Отчество
          </th>

          <th v-for="discipline in groupDisciplines" :key="discipline.id"
            class="text-center"
            :style="{'max-width': '120px'}"
          >
            <div>
              {{discipline.name}}
            </div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="student in groupAttestations"
          :key="student.studentFullName"
        >
          <td class="text-left">
            {{groupAttestations.indexOf(student) + 1}}
          </td>
          <td :style="{'text-align': 'left', 'font-size': '16px'}" class="tscroll">
            {{student.studentFullName}}
          </td>
          <td
            v-for="discipline in groupDisciplines"
            :key="discipline.id"
            :style="{'text-align': 'center', 'font-size': '14px'}"
          >
            <the-value-attestation-student-table-div
              :discipline="discipline"
              :student="student"
            />
          </td>
        </tr>
        <tr>
          <td class="text-center" colspan="2">
            <div class="text-h6">
              Преподаватели
            </div>
          </td>
          <td
            v-for="discipline in groupDisciplines"
            :key="discipline.id"
            :style="{'text-align': 'center', 'font-size': '14px'}"
          >
            <div>
              {{ discipline.teacher }}
            </div>
            <div v-if="tabPointDate === 0">
              <div v-show="discipline.date.first !== null">
                ({{discipline.date.first}})
              </div>
            </div>
            <div v-else>
              <div v-show="discipline.date.second !== null">
                ({{discipline.date.second}})
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<style scoped>
.tscroll {
  position: sticky;
  left: 0;
  background-color: white;
}

</style>